import call from "./call";
import {
  VoicesEngage,
  VoicesSyncKind,
  VoicesSyncStatus,
  VoicesToday,
} from "../Models/voicesOverview";
import { VoicesResults, VoicesResultsFilters } from "../Models/voicesResults";
import { saveDownload } from "../Helpers/voicesDownload";
import { voicesHeaders } from "../Helpers/voicesWorkspace";

export const getVoicesToday = async (): Promise<VoicesToday> => {
  const response = await call.get<VoicesToday>("/v1/voices/today/", {
    headers: voicesHeaders(),
  });
  return response.data;
};

export const getVoicesEngage = async (limit: number): Promise<VoicesEngage> => {
  const response = await call.get<VoicesEngage>("/v1/voices/engage/", {
    params: { limit },
    headers: voicesHeaders(),
    snack: { error: "voices.engageFetchError" },
  });
  return response.data;
};

export const getVoicesResults = async (filters: VoicesResultsFilters): Promise<VoicesResults> => {
  const response = await call.get<VoicesResults>("/v1/voices/results/", {
    params: filters,
    headers: voicesHeaders(),
    snack: { error: "voices.resultsFetchError" },
  });
  return response.data;
};

export const exportVoicesResults = async (filters: VoicesResultsFilters): Promise<void> => {
  const response = await call.get<Blob>("/v1/voices/results/export/", {
    params: filters,
    headers: voicesHeaders(),
    responseType: "blob",
    snack: { error: "voices.exportError", 404: "voices.resultsExportEmpty" },
  });
  saveDownload(response, "voices-results.csv");
};

export const startVoicesSync = async (
  kind: VoicesSyncKind,
  manual: boolean,
): Promise<VoicesSyncStatus> => {
  const response = await call.post<VoicesSyncStatus>(
    "/v1/voices/sync/",
    { kind, manual },
    { headers: voicesHeaders() },
  );
  return response.data;
};

export const getVoicesSyncStatus = async (): Promise<VoicesSyncStatus> => {
  const response = await call.get<VoicesSyncStatus>("/v1/voices/sync/", {
    headers: voicesHeaders(),
  });
  return response.data;
};
